// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30h6x","largestCol":"styles_largestCol__1KPfF","smallestCol":"styles_smallestCol__1WYnV"};